import React, { useEffect } from "react";

import "./portal.scss"

// Declaración global para PureCounter en window
declare global {
  interface Window {
    PureCounter?: any;
  }
}

export const PortalHome3: React.FC = () => {

  const [tabIndex, setTabIndex] = React.useState<string>('home');

  // Datos de ejemplo de profesionales
  const profesionalesData = [
    {
      nombre: 'Walter White',
      consultorio: 'Av. Spinetto 670, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-123456',
      matricula: '1234',
      cuit: '20-12345678-9',
      especialidades: ['Fonoaudiología', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Sarah Jhonson',
      consultorio: 'Belgrano 123, General Pico',
      localidad: 'General Pico',
      telefono: '2954-654321',
      matricula: '5678',
      cuit: '27-87654321-0',
      especialidades: ['Voz', 'Lenguaje'],
      atiendeObraSocial: false,
      redes: {
        // twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        // linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'William Anderson',
      consultorio: 'Rivadavia 456, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-789012',
      matricula: '9101',
      cuit: '23-11223344-5',
      especialidades: ['Odontoesmatología', 'Deglución'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Amanda Jepson',
      consultorio: 'San Martín 789, Toay',
      localidad: 'Toay',
      telefono: '2954-345678',
      matricula: '1121',
      cuit: '27-55667788-1',
      especialidades: ['Rehabilitación', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    // Nuevos profesionales de ejemplo
    {
      nombre: 'Lucía Fernández',
      consultorio: 'Av. Luro 1500, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-111222',
      matricula: '2233',
      cuit: '27-33445566-2',
      especialidades: ['Lenguaje', 'Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/luciaf',
        instagram: 'https://instagram.com/luciaf',
        linkedin: '',
      },
    },
    {
      nombre: 'Martín Gómez',
      consultorio: 'Calle 9 N° 456, General Pico',
      localidad: 'General Pico',
      telefono: '2954-333444',
      matricula: '3344',
      cuit: '20-99887766-3',
      especialidades: ['Audiología'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/mgomez',
        facebook: '',
        instagram: '',
        linkedin: 'https://linkedin.com/in/mgomez',
      },
    },
    {
      nombre: 'Paula Sosa',
      consultorio: 'Av. Perón 234, Toay',
      localidad: 'Toay',
      telefono: '2954-555666',
      matricula: '4455',
      cuit: '23-44556677-8',
      especialidades: ['Voz', 'Rehabilitación'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: '',
        instagram: 'https://instagram.com/paulasosa',
        linkedin: '',
      },
    },
    {
      nombre: 'Federico Ruiz',
      consultorio: 'Mitre 800, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-777888',
      matricula: '5566',
      cuit: '20-22334455-6',
      especialidades: ['Odontoesmatología', 'Lenguaje', 'Deglución'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/federicoruiz',
        facebook: '',
        instagram: '',
        linkedin: '',
      },
    },
    {
      nombre: 'María López',
      consultorio: 'Calle 25 N° 100, General Pico',
      localidad: 'General Pico',
      telefono: '2954-999000',
      matricula: '6677',
      cuit: '27-77889900-1',
      especialidades: ['Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/marialopez',
        instagram: '',
        linkedin: '',
      },
    },
  ];

  // Estado de filtros
  const [filtroNombre, setFiltroNombre] = React.useState('');
  const [filtroLocalidad, setFiltroLocalidad] = React.useState('');
  const [filtroObraSocial, setFiltroObraSocial] = React.useState('');
  const [filtroEspecialidad, setFiltroEspecialidad] = React.useState('');

  // Obtener opciones únicas de localidad y especialidad
  const localidades = Array.from(new Set(profesionalesData.map(p => p.localidad)));
  const especialidades = Array.from(new Set(profesionalesData.flatMap(p => p.especialidades)));

  // Filtrado de profesionales
  const profesionalesFiltrados = profesionalesData.filter(p => {
    const matchNombre = p.nombre.toLowerCase().includes(filtroNombre.toLowerCase()) || 
                       p.matricula.toLowerCase().includes(filtroNombre.toLowerCase());
    const matchLocalidad = !filtroLocalidad || p.localidad === filtroLocalidad;
    const matchObraSocial =
      !filtroObraSocial ||
      (filtroObraSocial === 'si' && p.atiendeObraSocial) ||
      (filtroObraSocial === 'no' && !p.atiendeObraSocial);
    const matchEspecialidad =
      !filtroEspecialidad || p.especialidades.includes(filtroEspecialidad);
    return matchNombre && matchLocalidad && matchObraSocial && matchEspecialidad;
  });

  useEffect(() => {
  if (tabIndex === 'institucional' && window.PureCounter) {
    new window.PureCounter();
  }
}, [tabIndex]);

  useEffect(() => {
    // Forzar viewport correcto para evitar escalado
    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (metaViewport) {
      metaViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }
    
    // Cargar scripts JS solo cuando el portal está montado
    const scripts = [
      './assets/portal/vendor/bootstrap/js/bootstrap.bundle.min.js',
      './assets/portal/vendor/php-email-form/validate.js',
      './assets/portal/vendor/aos/aos.js',
      './assets/portal/vendor/glightbox/js/glightbox.min.js',
      './assets/portal/vendor/purecounter/purecounter_vanilla.js',
      './assets/portal/js/main.js',
    ];
    const scriptElements = scripts.map(src => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    });
    // Cargar fuentes solo para el portal
    const fontLinks = [
      { href: 'https://fonts.googleapis.com', rel: 'preconnect' },
      { href: 'https://fonts.gstatic.com', rel: 'preconnect', crossorigin: 'anonymous' },
      { href: 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap', rel: 'stylesheet' },
      { href: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap', rel: 'stylesheet' }
    ];
    const linkElements = fontLinks.map(props => {
      const link = document.createElement('link');
      Object.entries(props).forEach(([key, value]) => link.setAttribute(key, value));
      document.head.appendChild(link);
      return link;
    });
    // Cargar estilos CSS solo para el portal
    const cssLinks = [
      '/assets/portal/vendor/bootstrap/css/bootstrap.min.css',
      '/assets/portal/vendor/bootstrap-icons/bootstrap-icons.css',
      '/assets/portal/vendor/aos/aos.css',
      '/assets/portal/vendor/fontawesome-free/css/all.min.css',
      '/assets/portal/vendor/glightbox/css/glightbox.min.css',
      '/assets/portal/vendor/swiper/swiper-bundle.min.css',
      '/assets/portal/css/main.css',
      '/assets/portal/css/portal-fix.css', // CSS fix para escalado
    ];
    const cssElements = cssLinks.map(href => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    return () => {
      scriptElements.forEach(script => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
      linkElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
      cssElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
    };
  }, []);

  return (
    <>
      {/* HEADER - ESTILO MÉDICO PROFESIONAL */}
      <header id="header" className="header sticky-top">
        <div className="topbar d-flex align-items-center" style={{
          background: '#2f3c68',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 2px 20px rgba(0, 0, 0, 0.1)',
          padding: '10px 0',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Elemento decorativo de fondo */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: `
              radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 50%)
            `,
            zIndex: 1
          }} />
          
          <div className="container d-flex justify-content-center justify-content-md-between" style={{
            position: 'relative',
            zIndex: 2
          }}>
            <div className="d-none d-md-flex align-items-center" style={{
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500',
              fontFamily: "'Poppins', sans-serif",
              textShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
              letterSpacing: '0.3px'
            }}>
              <i className="bi bi-building me-2" style={{
                fontSize: '1rem',
                color: '#ffd700'
              }}></i> 
              Colegio Profesional de Fonoaudiólogos de La Pampa
            </div>
            <a 
              href="https://wa.me/5429542954702284?text=Hola,%20necesito%20información%20sobre%20los%20servicios%20del%20Colegio%20de%20Fonoaudiólogos" 
              target="_blank" 
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{
                color: '#ffffff',
                fontSize: '0.9rem',
                fontWeight: '500',
                fontFamily: "'Poppins', sans-serif",
                textShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                letterSpacing: '0.3px',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                padding: '5px 10px',
                borderRadius: '25px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(5px)',
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(37, 211, 102, 0.2)';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(37, 211, 102, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <i className="bi bi-whatsapp me-2" style={{
                fontSize: '1rem',
                color: '#25d366',
                animation: 'topbarPulse 2s infinite'
              }}></i> 
              Contáctanos por WhatsApp
            </a>
          </div>
        </div>
        <div className="branding d-flex align-items-center">
          <div className="container position-relative d-flex align-items-center justify-content-end">
            <a href="index.html" className="logo d-flex align-items-center me-auto">
              <img src="assets/img/logo-cofolp.png" alt="" />
            </a>
            <nav id="navmenu" className="navmenu">
              <ul>
                <li><a href="#" className="active" onClick={() => setTabIndex('home')}>Inicio</a></li>
                <li className="dropdown"><a href='#' onClick={() => setTabIndex('institucional')}><span>Institucional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Quiénes somos?</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Comisión Directiva</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Tribunal de Ética y Disciplina</a></li>
                    <li><a href='#' onClick={() => setTabIndex('institucional')}>Comisión Revisora de Cuentas</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a href="#" onClick={() => setTabIndex('tramites')}><span>Trámites</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#" onClick={() => setTabIndex('matriculacion')}>Matriculación</a></li>
                    <li><a href="#" onClick={() => setTabIndex('consultorio')}>Consultorio</a></li>
                    <li><a href="#" onClick={() => setTabIndex('tramites')}>Título</a></li>
                    <li><a href="#" onClick={() => setTabIndex('tramites')}>Baja de Matrícula</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Habilitación de Consultorio</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}><span>Ejercicio Profesional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Honorarios Mínimos</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Código de Ética</a></li>
                    <li><a href="#" onClick={() => setTabIndex('certificado-etica')}>Certificado de Ética</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Consentimiento Informado</a></li>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Habilitación de Consultorio</a></li>
                  </ul>
                </li>
                <li><a href="#" onClick={() => setTabIndex('profesionales')}>Profesionales</a></li>
                <li><a href="#">Obras Sociales</a></li>
                <li><a href="#" onClick={() => setTabIndex('contacto')}>Contacto</a></li>
              </ul>
              <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
            </nav>
            <a className="cta-btn" 
               href="http://145.223.94.120/" 
               target="_blank" 
               rel="noopener noreferrer"
               style={{
                 background: '#f97316',
                 color: '#ffffff',
                 padding: '12px 24px',
                 borderRadius: '25px',
                 fontWeight: '600',
                 fontSize: '0.9rem',
                 textDecoration: 'none',
                 boxShadow: '0 4px 15px rgba(249, 115, 22, 0.3)',
                 transition: 'all 0.3s ease',
                 border: 'none',
                 textTransform: 'uppercase',
                 letterSpacing: '0.5px'
               }}
               onMouseEnter={(e) => {
                 e.currentTarget.style.transform = 'translateY(-2px)';
                 e.currentTarget.style.boxShadow = '0 8px 25px rgba(249, 115, 22, 0.4)';
                 e.currentTarget.style.background = '#ea580c';
               }}
               onMouseLeave={(e) => {
                 e.currentTarget.style.transform = 'translateY(0)';
                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(249, 115, 22, 0.3)';
                 e.currentTarget.style.background = '#f97316';
               }}
            >AUTOGESTION</a>
          </div>
        </div>
      </header>
      
      
      {/* MAIN CONTENT */}
      <main className="main">
        {tabIndex === 'home' && (
          <>
            <section id="hero" className="hero section" style={{
              position: 'relative',
              height: 'auto',
              minHeight: '320px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              background: '#2f3c68',
              overflow: 'visible',
              padding: '20px 0'
            }}>
              {/* Contenido principal */}
              <div style={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'relative',
                zIndex: 1,
                padding: '20px 0',
                overflow: 'visible'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '55%',
                  height: 'auto',
                  position: 'relative',
                  overflow: 'visible'
                }}>
                  <video 
                    autoPlay
                    muted
                    loop={false}
                    playsInline
                    style={{
                      width: '1600px',
                      height: 'auto',
                      objectFit: 'contain',
                      opacity: 0,
                      transform: 'translateY(20px)',
                      animation: 'scaleIn 1s ease-out 0.3s forwards'
                    }}
                    onLoadedData={(e) => {
                      // Asegurar que el video se reproduzca
                      e.currentTarget.play().catch(() => {
                        // Si autoplay falla, al menos mostrar el primer frame
                        e.currentTarget.currentTime = 0;
                      });
                    }}
                  >
                    <source src="./assets/portal/img/logo_banner.webm" type="video/webm" />
                    {/* Fallback para navegadores que no soporten webm */}
                    <img src="./assets/img/logo-cofolp.png" alt="Logo COFOLP" style={{
                      width: 'auto',
                      height: 'auto',
                      maxWidth: '100%',
                      maxHeight: '280px',
                      objectFit: 'contain'
                    }} />
                  </video>
                </div>
                <div
                  className="banner-text"
                  style={{
                    width: '45%',
                    height: 'auto',
                    maxWidth: '600px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 30px',
                    margin: '20px',
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%)',
                    backdropFilter: 'blur(15px)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1), 0 5px 15px rgba(0, 0, 0, 0.08)',
                    position: 'relative',
                    overflow: 'hidden',
                    opacity: 0,
                    transform: 'translateY(30px)',
                    animation: 'slideInUp 1.2s ease-out 0.8s forwards'
                  }}
                >
                  {/* Elemento decorativo de fondo */}
                  <div style={{
                    position: 'absolute',
                    top: '-50%',
                    right: '-30%',
                    width: '200px',
                    height: '200px',
                    background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.1), transparent)',
                    borderRadius: '50%',
                    zIndex: 1
                  }} />
                  
                  {/* Contenido del texto */}
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <h2 style={{
                      color: '#ffffff',
                      fontSize: '2.4rem',
                      fontWeight: '700',
                      lineHeight: '1.2',
                      textShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                      margin: 0,
                      fontFamily: "'Poppins', sans-serif",
                      letterSpacing: '-0.5px',
                      marginBottom: '12px'
                    }}>
                      El respaldo de la<br />
                      <span style={{
                        color: '#e67e22',
                        fontWeight: '800',
                        fontSize: '2.6rem'
                      }}>
                        Fonoaudiología
                      </span>
                      <br />en La Pampa
                    </h2>
                    
                    <div style={{
                      width: '60px',
                      height: '3px',
                      background: 'linear-gradient(90deg, #ffd700, #ffed4e)',
                      margin: '20px auto',
                      borderRadius: '2px'
                    }} />
                    
                    <p style={{
                      fontSize: '1.3rem',
                      fontWeight: '500',
                      color: 'rgba(255, 255, 255, 0.95)',
                      margin: 0,
                      fontFamily: "'Poppins', sans-serif",
                      letterSpacing: '0.3px',
                      textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
                    }}>
                      Regulación • Formación • Ética
                    </p>
                  </div>
                </div>
              </div>
              
              <style>{`
                /* Normalización CSS para evitar escalado no deseado */
                * {
                  box-sizing: border-box;
                }
                
                html {
                  font-size: 16px !important;
                  -webkit-text-size-adjust: 100% !important;
                  -ms-text-size-adjust: 100% !important;
                  text-size-adjust: 100% !important;
                }
                
                body {
                  font-size: 1rem !important;
                  line-height: 1.5 !important;
                  zoom: 1 !important;
                  transform: none !important;
                }
                
                .container, .container-fluid {
                  max-width: 1200px !important;
                  margin: 0 auto !important;
                }
                
                /* Prevenir escalado automático en dispositivos */
                @media screen and (max-device-width: 1024px) {
                  html {
                    -webkit-text-size-adjust: none !important;
                  }
                }
                
                /* Animaciones esenciales */
                @keyframes scaleIn {
                  0% {
                    opacity: 0;
                    transform: scale(0.8);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }
                
                @keyframes slideInUp {
                  0% {
                    opacity: 0;
                    transform: translateY(30px) scale(0.95);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                @keyframes topbarPulse {
                  0%, 100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                  50% {
                    opacity: 0.8;
                    transform: scale(1.05);
                  }
                }
                
                /* Responsive similar al PortalHome original */
                @media (max-width: 768px) {
                  /* Forzar tamaños fijos para evitar escalado */
                  html {
                    font-size: 14px !important;
                  }
                  
                  .topbar {
                    padding: 8px 0 !important;
                    font-size: 0.8rem !important;
                  }
                  
                  .topbar .container > div {
                    font-size: 0.85rem !important;
                  }
                  
                  #hero {
                    min-height: 400px !important;
                    padding: 40px 0 !important;
                    overflow: visible !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    flex-direction: column !important;
                    padding: 0 20px !important;
                    max-width: none !important;
                    justify-content: center !important;
                    align-items: center !important;
                  }
                  
                  #hero video {
                    height: 250px !important;
                    width: auto !important;
                    max-width: 95% !important;
                    object-fit: contain !important;
                  }
                  
                  /* Forzar tamaños de servicio */
                  .modern-service-card {
                    min-height: 280px !important;
                    padding: 30px 20px !important;
                    font-size: 0.9rem !important;
                  }
                  
                  .modern-service-card h4 {
                    font-size: 1.2rem !important;
                  }
                  
                  .service-icon {
                    width: 70px !important;
                    height: 70px !important;
                  }
                  
                  .service-icon i {
                    font-size: 1.7rem !important;
                  }
                }
                
                @media (max-width: 600px) {
                  #hero {
                    min-height: 350px !important;
                    padding: 30px 0 !important;
                    overflow: visible !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                    padding: 0 15px !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    padding: 0 !important;
                    padding-left: 15px !important;
                    justify-content: center !important;
                    align-items: center !important;
                    flex-direction: column !important;
                    display: flex !important;
                  }
                  
                  #hero video {
                    height: 220px !important;
                    width: auto !important;
                    max-width: 90% !important;
                    margin: 0 auto !important;
                    object-fit: contain !important;
                  }
                }
                
                @media (max-width: 480px) {
                  #hero {
                    min-height: 320px !important;
                    padding: 20px 0 !important;
                    overflow: visible !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                    padding: 0 10px !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    padding: 0 !important;
                    justify-content: center !important;
                    align-items: center !important;
                    flex-direction: column !important;
                    display: flex !important;
                  }
                  
                  #hero video {
                    height: 180px !important;
                    width: auto !important;
                    max-width: 90% !important;
                    margin: 0 auto !important;
                    object-fit: contain !important;
                  }
                }
              `}</style>
            </section>

            {/* Featured Services Section - ESTILO SIMILAR AL PORTAL ORIGINAL */}
            <section id="featured-services" className="featured-services section" style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              padding: '40px 0',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Elementos decorativos de fondo con nueva paleta de colores */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '300px',
                height: '300px',
                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(59, 130, 246, 0.06))',
                borderRadius: '50%',
                zIndex: 1
              }} />
              <div style={{
                position: 'absolute',
                bottom: '-100px',
                left: '-100px',
                width: '400px',
                height: '400px',
                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.08), rgba(245, 158, 11, 0.06))',
                borderRadius: '50%',
                zIndex: 1
              }} />

              <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                <div className="row gy-4 justify-content-center">
                  {/* Servicio 1: Acceso a AUTOGESTION */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                    <div className="modern-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(217, 119, 6, 0.08) 100%)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '20px',
                      padding: '40px 30px',
                      textAlign: 'center',
                      border: '1px solid rgba(245, 158, 11, 0.2)',
                      boxShadow: '0 20px 40px rgba(245, 158, 11, 0.1)',
                      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '320px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                      e.currentTarget.style.boxShadow = '0 30px 60px rgba(245, 158, 11, 0.25)';
                      e.currentTarget.style.borderColor = 'rgba(245, 158, 11, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(245, 158, 11, 0.1)';
                      e.currentTarget.style.borderColor = 'rgba(245, 158, 11, 0.2)';
                    }}
                    onClick={() => window.open('http://145.223.94.120/', '_blank')}>
                      {/* Elemento decorativo */}
                      <div style={{
                        position: 'absolute',
                        top: '-20px',
                        right: '-20px',
                        width: '100px',
                        height: '100px',
                        background: 'linear-gradient(45deg, rgba(245, 158, 11, 0.15), transparent)',
                        borderRadius: '50%',
                        zIndex: 1
                      }} />
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="service-icon" style={{
                          width: '80px',
                          height: '80px',
                          background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 10px 30px rgba(245, 158, 11, 0.3)'
                        }}>
                          <i className="fas fa-laptop-code" style={{
                            fontSize: '2rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.4rem',
                          fontWeight: '600',
                          color: '#1e293b',
                          marginBottom: '15px',
                          fontFamily: "'Poppins', sans-serif"
                        }}>
                          Acceso a AUTOGESTION
                        </h4>
                        
                        <p style={{
                          color: '#64748b',
                          fontSize: '1rem',
                          lineHeight: '1.6',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Gestione sus trámites, consulte su estado de cuenta y acceda a todos los servicios digitales del colegio.
                        </p>
                        
                        <div style={{
                          marginTop: '20px',
                          padding: '10px 20px',
                          background: 'linear-gradient(90deg, #f59e0b, #d97706)',
                          color: 'white',
                          borderRadius: '25px',
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          display: 'inline-block'
                        }}>
                          Ingresar Ahora →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 2: Buscar Fonoaudiólogo */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                    <div className="modern-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(37, 99, 235, 0.08) 100%)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '20px',
                      padding: '40px 30px',
                      textAlign: 'center',
                      border: '1px solid rgba(59, 130, 246, 0.2)',
                      boxShadow: '0 20px 40px rgba(59, 130, 246, 0.1)',
                      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '320px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                      e.currentTarget.style.boxShadow = '0 30px 60px rgba(59, 130, 246, 0.25)';
                      e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(59, 130, 246, 0.1)';
                      e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.2)';
                    }}
                    onClick={() => setTabIndex('profesionales')}>
                      {/* Elemento decorativo */}
                      <div style={{
                        position: 'absolute',
                        top: '-20px',
                        right: '-20px',
                        width: '100px',
                        height: '100px',
                        background: 'linear-gradient(45deg, rgba(59, 130, 246, 0.15), transparent)',
                        borderRadius: '50%',
                        zIndex: 1
                      }} />
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="service-icon" style={{
                          width: '80px',
                          height: '80px',
                          background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 10px 30px rgba(59, 130, 246, 0.3)'
                        }}>
                          <i className="fas fa-user-md" style={{
                            fontSize: '2rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.4rem',
                          fontWeight: '600',
                          color: '#1e293b',
                          marginBottom: '15px',
                          fontFamily: "'Poppins', sans-serif"
                        }}>
                          Buscar Fonoaudiólogo
                        </h4>
                        
                        <p style={{
                          color: '#64748b',
                          fontSize: '1rem',
                          lineHeight: '1.6',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Encuentre profesionales matriculados por especialidad, localidad y cobertura de obra social.
                        </p>
                        
                        <div style={{
                          marginTop: '20px',
                          padding: '10px 20px',
                          background: 'linear-gradient(90deg, #3b82f6, #2563eb)',
                          color: 'white',
                          borderRadius: '25px',
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          display: 'inline-block'
                        }}>
                          Buscar Ahora →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 3: Próximos Cursos y Eventos */}
                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                    <div className="modern-service-card" style={{
                      background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.08) 100%)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '20px',
                      padding: '40px 30px',
                      textAlign: 'center',
                      border: '1px solid rgba(16, 185, 129, 0.2)',
                      boxShadow: '0 20px 40px rgba(16, 185, 129, 0.1)',
                      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100%',
                      minHeight: '320px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                      e.currentTarget.style.boxShadow = '0 30px 60px rgba(16, 185, 129, 0.25)';
                      e.currentTarget.style.borderColor = 'rgba(16, 185, 129, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(16, 185, 129, 0.1)';
                      e.currentTarget.style.borderColor = 'rgba(16, 185, 129, 0.2)';
                    }}
                    onClick={() => {
                      alert('Sección de Cursos y Eventos próximamente disponible');
                    }}>
                      {/* Elemento decorativo */}
                      <div style={{
                        position: 'absolute',
                        top: '-20px',
                        right: '-20px',
                        width: '100px',
                        height: '100px',
                        background: 'linear-gradient(45deg, rgba(16, 185, 129, 0.15), transparent)',
                        borderRadius: '50%',
                        zIndex: 1
                      }} />
                      
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div className="service-icon" style={{
                          width: '80px',
                          height: '80px',
                          background: 'linear-gradient(135deg, #10b981, #059669)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 20px',
                          boxShadow: '0 10px 30px rgba(16, 185, 129, 0.3)'
                        }}>
                          <i className="fas fa-graduation-cap" style={{
                            fontSize: '2rem',
                            color: 'white'
                          }}></i>
                        </div>
                        
                        <h4 style={{
                          fontSize: '1.4rem',
                          fontWeight: '600',
                          color: '#1e293b',
                          marginBottom: '15px',
                          fontFamily: "'Poppins', sans-serif"
                        }}>
                          Próximos Cursos y Eventos
                        </h4>
                        
                        <p style={{
                          color: '#64748b',
                          fontSize: '1rem',
                          lineHeight: '1.6',
                          margin: 0,
                          fontFamily: "'Inter', sans-serif"
                        }}>
                          Manténgase actualizado con los últimos cursos, seminarios y eventos de formación profesional.
                        </p>
                        
                        <div style={{
                          marginTop: '20px',
                          padding: '10px 20px',
                          background: 'linear-gradient(90deg, #10b981, #059669)',
                          color: 'white',
                          borderRadius: '25px',
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          display: 'inline-block'
                        }}>
                          Ver Eventos →
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Estilos CSS similares al PortalHome original */}
              <style>{`
                .modern-service-card:hover .service-icon {
                  transform: scale(1.1) rotate(5deg);
                  transition: all 0.3s ease;
                }
                
                @media (max-width: 768px) {
                  .modern-service-card {
                    min-height: 280px !important;
                    padding: 30px 20px !important;
                  }
                  
                  .modern-service-card h4 {
                    font-size: 1.2rem !important;
                  }
                  
                  .service-icon {
                    width: 70px !important;
                    height: 70px !important;
                  }
                  
                  .service-icon i {
                    font-size: 1.7rem !important;
                  }
                }
                
                @media (max-width: 480px) {
                  .modern-service-card {
                    margin: 10px !important;
                    min-height: 260px !important;
                  }
                }
              `}</style>
            </section>
          </>
        )}

        {/* Resto de secciones iguales al PortalHome original... */}
        {tabIndex === 'institucional' && (
          <>
           {/* Stats Section */}
            <section id="stats" className="stats section" style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
              color: '#e2e8f0'
            }}>
              <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gy-4">
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === 'profesionales' && (
                <div className="profesionales">
                  {/* Modern Professionals Section */}
                  <section id="profesionales" className="professionals section" style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
      
                    <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                      {/* Título moderno */}
                      <div className="row">
                        <div className="col-lg-12 text-center mb-5" data-aos="fade-up">
                          <h2 style={{
                            fontSize: '3rem',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '15px',
                            fontFamily: "'Poppins', sans-serif",
                            textShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                          }}>
                            Nuestros <span style={{
                              color: '#38bdf8'
                            }}>Profesionales</span>
                          </h2>
                          <p style={{
                            fontSize: '1.2rem',
                            color: '#64748b',
                            maxWidth: '600px',
                            margin: '0 auto',
                            fontFamily: "'Inter', sans-serif"
                          }}>
                            Encuentra a nuestros profesionales matriculados especializados en fonoaudiología
                          </p>
                        </div>
                      </div>
      
                      {/* Filtros modernos con glassmorphism */}
                      <div className="row mb-5" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-12">
                          <div style={{
                            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
                            backdropFilter: 'blur(15px)',
                            borderRadius: '20px',
                            padding: '30px',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            boxShadow: '0 15px 35px rgba(0, 0, 0, 0.08)'
                          }}>
                            <div className="row g-3">
                              <div className="col-md-3">
                                <label style={{
                                  display: 'block',
                                  marginBottom: '8px',
                                  fontWeight: '600',
                                  color: '#374151',
                                  fontSize: '0.9rem',
                                  fontFamily: "'Poppins', sans-serif"
                                }}>
                                  <i className="bi bi-person me-2" style={{ color: '#38bdf8' }}></i>
                                  <i className="bi bi-card-text me-2" style={{ color: '#0ea5e9' }}></i>
                                  Buscar por nombre o matrícula
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Nombre o N° de matrícula"
                                  value={filtroNombre}
                                  onChange={e => setFiltroNombre(e.target.value)}
                                  style={{
                                    borderRadius: '12px',
                                    border: '1px solid rgba(56, 189, 248, 0.3)',
                                    padding: '12px 16px',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.3s ease',
                                    background: 'rgba(255, 255, 255, 0.8)'
                                  }}
                                />
                                <small style={{
                                  color: '#64748b',
                                  fontSize: '0.8rem',
                                  fontStyle: 'italic',
                                  marginTop: '4px',
                                  display: 'block'
                                }}>
                                  Ejemplo: "Juan" o "143"
                                </small>
                              </div>
                              <div className="col-md-3">
                                <label style={{
                                  display: 'block',
                                  marginBottom: '8px',
                                  fontWeight: '600',
                                  color: '#374151',
                                  fontSize: '0.9rem',
                                  fontFamily: "'Poppins', sans-serif"
                                }}>
                                  <i className="bi bi-geo-alt me-2" style={{ color: '#2f3c68' }}></i>
                                  Localidad
                                </label>
                                <select
                                  className="form-select"
                                  value={filtroLocalidad}
                                  onChange={e => setFiltroLocalidad(e.target.value)}
                                  style={{
                                    borderRadius: '12px',
                                    border: '1px solid rgba(47, 60, 104, 0.3)',
                                    padding: '12px 16px',
                                    fontSize: '0.95rem',
                                    background: 'rgba(255, 255, 255, 0.8)'
                                  }}
                                >
                                  <option value="">Todas las localidades</option>
                                  {localidades.map(loc => (
                                    <option key={loc} value={loc}>{loc}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-md-3">
                                <label style={{
                                  display: 'block',
                                  marginBottom: '8px',
                                  fontWeight: '600',
                                  color: '#374151',
                                  fontSize: '0.9rem',
                                  fontFamily: "'Poppins', sans-serif"
                                }}>
                                  <i className="bi bi-heart-pulse me-2" style={{ color: '#38bdf8' }}></i>
                                  Obra Social
                                </label>
                                <select
                                  className="form-select"
                                  value={filtroObraSocial}
                                  onChange={e => setFiltroObraSocial(e.target.value)}
                                  style={{
                                    borderRadius: '12px',
                                    border: '1px solid rgba(56, 189, 248, 0.3)',
                                    padding: '12px 16px',
                                    fontSize: '0.95rem',
                                    background: 'rgba(255, 255, 255, 0.8)'
                                  }}
                                >
                                  <option value="">Todos</option>
                                  <option value="si">Atiende Obra Social</option>
                                  <option value="no">No atiende Obra Social</option>
                                </select>
                              </div>
                              <div className="col-md-3">
                                <label style={{
                                  display: 'block',
                                  marginBottom: '8px',
                                  fontWeight: '600',
                                  color: '#374151',
                                  fontSize: '0.9rem',
                                  fontFamily: "'Poppins', sans-serif"
                                }}>
                                  <i className="bi bi-bookmark me-2" style={{ color: '#0ea5e9' }}></i>
                                  Especialidad
                                </label>
                                <select
                                  className="form-select"
                                  value={filtroEspecialidad}
                                  onChange={e => setFiltroEspecialidad(e.target.value)}
                                  style={{
                                    borderRadius: '12px',
                                    border: '1px solid rgba(14, 165, 233, 0.3)',
                                    padding: '12px 16px',
                                    fontSize: '0.95rem',
                                    background: 'rgba(255, 255, 255, 0.8)'
                                  }}
                                >
                                  <option value="">Todas las especialidades</option>
                                  {especialidades.map(esp => (
                                    <option key={esp} value={esp}>{esp}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
      
                      {/* Tabla moderna de profesionales */}
                      <div className="row">
                        <div className="col-12" data-aos="fade-up" data-aos-delay="200">
                          {profesionalesFiltrados.length === 0 ? (
                            <div style={{
                              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
                              backdropFilter: 'blur(15px)',
                              borderRadius: '20px',
                              padding: '60px 40px',
                              border: '1px solid rgba(255, 255, 255, 0.3)',
                              boxShadow: '0 15px 35px rgba(0, 0, 0, 0.08)',
                              textAlign: 'center'
                            }}>
                              <i className="bi bi-search" style={{
                                fontSize: '3rem',
                                color: '#94a3b8',
                                marginBottom: '20px'
                              }}></i>
                              <h4 style={{
                                color: '#64748b',
                                fontFamily: "'Poppins', sans-serif",
                                marginBottom: '10px'
                              }}>
                                No se encontraron profesionales
                              </h4>
                              <p style={{
                                color: '#94a3b8',
                                fontSize: '1rem'
                              }}>
                                Intenta ajustar los filtros de búsqueda
                              </p>
                            </div>
                          ) : (
                            <div style={{
                              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
                              backdropFilter: 'blur(15px)',
                              borderRadius: '20px',
                              border: '1px solid rgba(255, 255, 255, 0.3)',
                              boxShadow: '0 15px 35px rgba(0, 0, 0, 0.08)',
                              overflow: 'hidden'
                            }}>
                              {/* Header de tabla para escritorio */}
                              <div className="d-none d-lg-block">
                                <div className="professional-table-header" style={{
                                  display: 'grid',
                                  gridTemplateColumns: '200px 200px 150px 120px 180px 120px 180px',
                                  gap: '20px',
                                  padding: '25px 30px',
                                  background: 'linear-gradient(135deg, rgba(56, 189, 248, 0.1), rgba(47, 60, 104, 0.08))',
                                  borderBottom: '1px solid rgba(56, 189, 248, 0.2)',
                                  fontFamily: "'Poppins', sans-serif",
                                  alignItems: 'center'
                                }}>
                                  <div style={{ 
                                    fontWeight: '600', 
                                    color: '#1e293b', 
                                    fontSize: '0.9rem',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}>
                                    <i className="bi bi-person-circle me-2" style={{ color: '#38bdf8' }}></i>
                                    Profesional
                                  </div>
                                  <div style={{ 
                                    fontWeight: '600', 
                                    color: '#1e293b', 
                                    fontSize: '0.9rem',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}>
                                    <i className="bi bi-geo-alt me-2" style={{ color: '#2f3c68' }}></i>
                                    Consultorio
                                  </div>
                                  <div style={{ 
                                    fontWeight: '600', 
                                    color: '#1e293b', 
                                    fontSize: '0.9rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <i className="bi bi-telephone me-2" style={{ color: '#0ea5e9' }}></i>
                                    Teléfono
                                  </div>
                                  <div style={{ 
                                    fontWeight: '600', 
                                    color: '#1e293b', 
                                    fontSize: '0.9rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <i className="bi bi-card-text me-2" style={{ color: '#38bdf8' }}></i>
                                    Matrícula
                                  </div>
                                  <div style={{ 
                                    fontWeight: '600', 
                                    color: '#1e293b', 
                                    fontSize: '0.9rem',
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}>
                                    <i className="bi bi-bookmark me-2" style={{ color: '#0ea5e9' }}></i>
                                    Especialidades
                                  </div>
                                  <div style={{ 
                                    fontWeight: '600', 
                                    color: '#1e293b', 
                                    fontSize: '0.9rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <i className="bi bi-heart-pulse me-2" style={{ color: '#38bdf8' }}></i>
                                    Obra Social
                                  </div>
                                  <div style={{ 
                                    fontWeight: '600', 
                                    color: '#1e293b', 
                                    fontSize: '0.9rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <i className="bi bi-share me-2" style={{ color: '#2f3c68' }}></i>
                                    Redes
                                  </div>
                                </div>
                              </div>
      
                              {/* Filas de profesionales */}
                              <div>
                                {profesionalesFiltrados.map((profesional, idx) => {
                                  // Esquema de colores profesional simplificado - celeste del logo y azul marino
                                  const colorSchemes = [
                                    { // Celeste del logo
                                      primary: '#38bdf8',
                                      secondary: '#0ea5e9',
                                      shadowRgba: 'rgba(56, 189, 248, 0.25)',
                                      hoverRgba: 'rgba(56, 189, 248, 0.04)'
                                    },
                                    { // Azul marino profesional
                                      primary: '#2f3c68',
                                      secondary: '#3f4e7a',
                                      shadowRgba: 'rgba(47, 60, 104, 0.25)',
                                      hoverRgba: 'rgba(47, 60, 104, 0.04)'
                                    }
                                  ];
                                  
                                  const currentColorScheme = colorSchemes[idx % colorSchemes.length];
                                  
                                  return (
                                  <React.Fragment key={profesional.nombre + idx}>
                                    {/* Vista de escritorio */}
                                    <div 
                                      style={{
                                        display: 'grid',
                                        gridTemplateColumns: '200px 200px 150px 120px 180px 120px 180px',
                                        gap: '20px',
                                        padding: '20px 30px',
                                        borderBottom: idx < profesionalesFiltrados.length - 1 ? '1px solid rgba(226, 232, 240, 0.6)' : 'none',
                                        transition: 'all 0.3s ease',
                                        fontFamily: "'Inter', sans-serif",
                                        fontSize: '0.9rem',
                                        alignItems: 'center'
                                      }}
                                      className="professional-table-row d-none d-lg-grid"
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.background = currentColorScheme.hoverRgba;
                                        e.currentTarget.style.transform = 'translateX(5px)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.transform = 'translateX(0)';
                                      }}
                                    >
                                      {/* Profesional */}
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                      }}>
                                        <div style={{
                                          width: '45px',
                                          height: '45px',
                                          background: `linear-gradient(135deg, ${currentColorScheme.primary}, ${currentColorScheme.secondary})`,
                                          borderRadius: '50%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          boxShadow: `0 4px 15px ${currentColorScheme.shadowRgba}`,
                                          flexShrink: 0
                                        }}>
                                          <i className="fas fa-user-md" style={{
                                            fontSize: '1.1rem',
                                            color: 'white'
                                          }}></i>
                                        </div>
                                        <div>
                                          <div style={{
                                            fontWeight: '600',
                                            color: '#1e293b',
                                            fontSize: '0.95rem',
                                            marginBottom: '2px',
                                            lineHeight: '1.2'
                                          }}>
                                            {profesional.nombre}
                                          </div>
                                          <div style={{
                                            color: '#64748b',
                                            fontSize: '0.8rem'
                                          }}>
                                            {profesional.localidad}
                                          </div>
                                        </div>
                                      </div>
      
                                      {/* Consultorio */}
                                      <div style={{
                                        color: '#64748b',
                                        lineHeight: '1.4',
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '0.85rem'
                                      }}>
                                        {profesional.consultorio}
                                      </div>
      
                                      {/* Teléfono */}
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                      }}>
                                        <a 
                                          href={`tel:${profesional.telefono}`}
                                          style={{
                                            color: currentColorScheme.secondary,
                                            textDecoration: 'none',
                                            fontWeight: '500',
                                            transition: 'color 0.2s ease',
                                            fontSize: '0.85rem',
                                            textAlign: 'center'
                                          }}
                                          onMouseEnter={(e) => e.currentTarget.style.color = currentColorScheme.primary}
                                          onMouseLeave={(e) => e.currentTarget.style.color = currentColorScheme.secondary}
                                        >
                                          {profesional.telefono}
                                        </a>
                                      </div>
      
                                      {/* Matrícula */}
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#64748b',
                                        fontWeight: '500',
                                        fontSize: '0.85rem'
                                      }}>
                                        {profesional.matricula}
                                      </div>
      
                                      {/* Especialidades */}
                                      <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '4px',
                                        alignItems: 'center'
                                      }}>
                                        {profesional.especialidades.slice(0, 2).map(esp => (
                                          <span key={esp} style={{
                                            background: `linear-gradient(135deg, ${currentColorScheme.primary}15, ${currentColorScheme.secondary}15)`,
                                            color: currentColorScheme.primary,
                                            padding: '2px 8px',
                                            borderRadius: '12px',
                                            fontSize: '0.7rem',
                                            fontWeight: '500',
                                            border: `1px solid ${currentColorScheme.primary}30`,
                                            whiteSpace: 'nowrap'
                                          }}>
                                            {esp}
                                          </span>
                                        ))}
                                        {profesional.especialidades.length > 2 && (
                                          <span style={{
                                            background: 'rgba(100, 116, 139, 0.1)',
                                            color: '#64748b',
                                            padding: '2px 6px',
                                            borderRadius: '12px',
                                            fontSize: '0.65rem',
                                            fontWeight: '500'
                                          }}>
                                            +{profesional.especialidades.length - 2}
                                          </span>
                                        )}
                                      </div>
      
                                      {/* Obra Social */}
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                      }}>
                                        {profesional.atiendeObraSocial ? (
                                          <div style={{
                                            background: 'linear-gradient(135deg, rgba(47, 60, 104, 0.1), rgba(59, 130, 246, 0.1))',
                                            color: '#2f3c68',
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            fontSize: '0.75rem',
                                            fontWeight: '600',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            border: '1px solid rgba(47, 60, 104, 0.2)'
                                          }}>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Sí
                                          </div>
                                        ) : (
                                          <div style={{
                                            background: 'rgba(148, 163, 184, 0.1)',
                                            color: '#94a3b8',
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            fontSize: '0.75rem',
                                            fontWeight: '500'
                                          }}>
                                            No
                                          </div>
                                        )}
                                      </div>
      
                                      {/* Redes sociales */}
                                      <div style={{
                                        display: 'flex',
                                        gap: '6px',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                      }}>
                                        {profesional.redes.twitter && (
                                          <a href={profesional.redes.twitter} target="_blank" rel="noopener noreferrer" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '28px',
                                            height: '28px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #1da1f2, #0d8bd9)',
                                            color: 'white',
                                            textDecoration: 'none',
                                            transition: 'transform 0.2s ease'
                                          }}>
                                            <i className="bi bi-twitter-x" style={{ fontSize: '0.8rem' }}></i>
                                          </a>
                                        )}
                                        {profesional.redes.facebook && (
                                          <a href={profesional.redes.facebook} target="_blank" rel="noopener noreferrer" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '28px',
                                            height: '28px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #3b5998, #2d4373)',
                                            color: 'white',
                                            textDecoration: 'none',
                                            transition: 'transform 0.2s ease'
                                          }}>
                                            <i className="bi bi-facebook" style={{ fontSize: '0.8rem' }}></i>
                                          </a>
                                        )}
                                        {profesional.redes.instagram && (
                                          <a href={profesional.redes.instagram} target="_blank" rel="noopener noreferrer" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '28px',
                                            height: '28px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #e4405f, #c13584)',
                                            color: 'white',
                                            textDecoration: 'none',
                                            transition: 'transform 0.2s ease'
                                          }}>
                                            <i className="bi bi-instagram" style={{ fontSize: '0.8rem' }}></i>
                                          </a>
                                        )}
                                        {profesional.redes.linkedin && (
                                          <a href={profesional.redes.linkedin} target="_blank" rel="noopener noreferrer" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '28px',
                                            height: '28px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #0077b5, #005885)',
                                            color: 'white',
                                            textDecoration: 'none',
                                            transition: 'transform 0.2s ease'
                                          }}>
                                            <i className="bi bi-linkedin" style={{ fontSize: '0.8rem' }}></i>
                                          </a>
                                        )}
                                      </div>
                                    </div>
      
                                    {/* Vista móvil - Cards compactas */}
                                    <div 
                                      className="d-lg-none"
                                      style={{
                                        padding: '20px',
                                        borderBottom: idx < profesionalesFiltrados.length - 1 ? '1px solid rgba(226, 232, 240, 0.6)' : 'none'
                                      }}
                                    >
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '15px',
                                        marginBottom: '15px'
                                      }}>
                                        <div style={{
                                          width: '50px',
                                          height: '50px',
                                          background: `linear-gradient(135deg, ${currentColorScheme.primary}, ${currentColorScheme.secondary})`,
                                          borderRadius: '50%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          boxShadow: `0 4px 15px ${currentColorScheme.shadowRgba}`,
                                          flexShrink: 0
                                        }}>
                                          <i className="fas fa-user-md" style={{
                                            fontSize: '1.2rem',
                                            color: 'white'
                                          }}></i>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                          <h5 style={{
                                            fontWeight: '600',
                                            color: '#1e293b',
                                            margin: '0 0 5px 0',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '1.1rem'
                                          }}>
                                            {profesional.nombre}
                                          </h5>
                                          <div style={{
                                            color: '#64748b',
                                            fontSize: '0.85rem',
                                            marginBottom: '8px'
                                          }}>
                                            <i className="bi bi-geo-alt-fill me-1" style={{ color: '#2f3c68' }}></i>
                                            {profesional.consultorio}
                                          </div>
                                          <div style={{
                                            color: '#64748b',
                                            fontSize: '0.85rem'
                                          }}>
                                            <i className="bi bi-telephone-fill me-1" style={{ color: currentColorScheme.secondary }}></i>
                                            <a href={`tel:${profesional.telefono}`} style={{
                                              color: currentColorScheme.secondary,
                                              textDecoration: 'none'
                                            }}>
                                              {profesional.telefono}
                                            </a>
                                            <span className="ms-3">
                                              <i className="bi bi-card-text me-1" style={{ color: currentColorScheme.primary }}></i>
                                              Mat. {profesional.matricula}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      
                                      {/* Especialidades móvil */}
                                      <div style={{ marginBottom: '12px' }}>
                                        <div style={{
                                          display: 'flex',
                                          flexWrap: 'wrap',
                                          gap: '5px'
                                        }}>
                                          {profesional.especialidades.map(esp => (
                                            <span key={esp} style={{
                                              background: `linear-gradient(135deg, ${currentColorScheme.primary}15, ${currentColorScheme.secondary}15)`,
                                              color: currentColorScheme.primary,
                                              padding: '3px 10px',
                                              borderRadius: '12px',
                                              fontSize: '0.75rem',
                                              fontWeight: '500',
                                              border: `1px solid ${currentColorScheme.primary}30`
                                            }}>
                                              {esp}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
      
                                      {/* Footer móvil */}
                                      <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        paddingTop: '12px',
                                        borderTop: '1px solid rgba(226, 232, 240, 0.6)'
                                      }}>
                                        <div>
                                          {profesional.atiendeObraSocial ? (
                                            <div style={{
                                              background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.1), rgba(16, 185, 129, 0.1))',
                                              color: '#10b981',
                                              padding: '4px 10px',
                                              borderRadius: '15px',
                                              fontSize: '0.7rem',
                                              fontWeight: '600',
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: '3px',
                                              border: '1px solid rgba(34, 197, 94, 0.2)'
                                            }}>
                                              <i className="bi bi-check-circle-fill"></i>
                                              Obra Social
                                            </div>
                                          ) : (
                                            <div style={{
                                              background: 'rgba(148, 163, 184, 0.1)',
                                              color: '#94a3b8',
                                              padding: '4px 10px',
                                              borderRadius: '15px',
                                              fontSize: '0.7rem',
                                              fontWeight: '500'
                                            }}>
                                              Sin Obra Social
                                            </div>
                                          )}
                                        </div>
                                        <div style={{
                                          display: 'flex',
                                          gap: '6px'
                                        }}>
                                          {profesional.redes.twitter && (
                                            <a href={profesional.redes.twitter} target="_blank" rel="noopener noreferrer" style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              width: '32px',
                                              height: '32px',
                                              borderRadius: '50%',
                                              background: 'linear-gradient(135deg, #1da1f2, #0d8bd9)',
                                              color: 'white',
                                              textDecoration: 'none'
                                            }}>
                                              <i className="bi bi-twitter-x" style={{ fontSize: '0.9rem' }}></i>
                                            </a>
                                          )}
                                          {profesional.redes.facebook && (
                                            <a href={profesional.redes.facebook} target="_blank" rel="noopener noreferrer" style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              width: '32px',
                                              height: '32px',
                                              borderRadius: '50%',
                                              background: 'linear-gradient(135deg, #3b5998, #2d4373)',
                                              color: 'white',
                                              textDecoration: 'none'
                                            }}>
                                              <i className="bi bi-facebook" style={{ fontSize: '0.9rem' }}></i>
                                            </a>
                                          )}
                                          {profesional.redes.instagram && (
                                            <a href={profesional.redes.instagram} target="_blank" rel="noopener noreferrer" style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              width: '32px',
                                              height: '32px',
                                              borderRadius: '50%',
                                              background: 'linear-gradient(135deg, #e4405f, #c13584)',
                                              color: 'white',
                                              textDecoration: 'none'
                                            }}>
                                              <i className="bi bi-instagram" style={{ fontSize: '0.9rem' }}></i>
                                            </a>
                                          )}
                                          {profesional.redes.linkedin && (
                                            <a href={profesional.redes.linkedin} target="_blank" rel="noopener noreferrer" style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              width: '32px',
                                              height: '32px',
                                              borderRadius: '50%',
                                              background: 'linear-gradient(135deg, #0077b5, #005885)',
                                              color: 'white',
                                              textDecoration: 'none'
                                            }}>
                                              <i className="bi bi-linkedin" style={{ fontSize: '0.9rem' }}></i>
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </React.Fragment>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
      
                    {/* Estilos CSS */}
                    <style>{`
                      .form-control:focus, .form-select:focus {
                        border-color: #e67e22 !important;
                        box-shadow: 0 0 0 0.2rem rgba(230, 126, 34, 0.25) !important;
                        outline: none;
                      }
                      
                      .professional-table-row:hover .bi {
                        transform: scale(1.1);
                      }
                      
                      @media (max-width: 768px) {
                        .professionals.section {
                          padding: 60px 0 !important;
                        }
                        
                        .professionals h2 {
                          font-size: 2.2rem !important;
                        }
                        
                        .professionals .col-12 div[style*="padding: 30px"] {
                          padding: 20px !important;
                        }
                      }
                      
                      @media (max-width: 480px) {
                        .professionals.section {
                          padding: 40px 0 !important;
                        }
                        
                        .professionals h2 {
                          font-size: 1.8rem !important;
                        }
                        
                        .professionals .col-12 div[style*="padding: 20px"] {
                          padding: 15px !important;
                        }
                      }
                    `}</style>
                  </section>
                </div>
              )}
      </main>

      
      
      {/* FOOTER - ESTILO ELEGANTE Y PROFESIONAL */}
      <footer id="footer" className="footer" style={{
        background: '#2f3c68',
        position: 'relative',
        overflow: 'hidden',
        padding: '60px 0 20px 0'
      }}>
        {/* Elementos decorativos de fondo */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `
            radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 50%, rgba(230, 126, 34, 0.08) 0%, transparent 50%)
          `,
          zIndex: 1
        }} />

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row gy-4">
            {/* Información del Colegio */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-info">
                <h3 style={{
                  color: '#ffffff',
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontFamily: "'Poppins', sans-serif"
                }}>COFOLP</h3>
                <p style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: '0.95rem',
                  lineHeight: '1.6',
                  marginBottom: '20px',
                  fontFamily: "'Inter', sans-serif"
                }}>
                  Colegio Profesional de Fonoaudiólogos de La Pampa. 
                  Regulando y promoviendo la excelencia en el ejercicio profesional.
                </p>
                <div className="footer-contact">
                  <p style={{ 
                    color: 'rgba(255, 255, 255, 0.9)', 
                    marginBottom: '8px',
                    fontSize: '0.9rem',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <i className="bi bi-geo-alt me-2" style={{ color: '#e67e22' }}></i>
                    Av. Spinetto 670, Santa Rosa - La Pampa
                  </p>
                  <p style={{ 
                    color: 'rgba(255, 255, 255, 0.9)', 
                    marginBottom: '8px',
                    fontSize: '0.9rem',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <i className="bi bi-telephone me-2" style={{ color: '#e67e22' }}></i>
                    +54 2954 702284
                  </p>
                  <p style={{ 
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: '0.9rem',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <i className="bi bi-envelope me-2" style={{ color: '#e67e22' }}></i>
                    cofolp@gmail.com
                  </p>
                </div>
              </div>
            </div>

            {/* Enlaces Principales */}
            <div className="col-lg-2 col-md-3 col-6">
              <div className="footer-links">
                <h4 style={{
                  color: '#e67e22',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontFamily: "'Poppins', sans-serif"
                }}>Enlaces</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('home')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Inicio
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('institucional')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Institucional
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('profesionales')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Profesionales
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('contacto')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Contacto
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Trámites */}
            <div className="col-lg-2 col-md-3 col-6">
              <div className="footer-links">
                <h4 style={{
                  color: '#e67e22',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontFamily: "'Poppins', sans-serif"
                }}>Trámites</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('matriculacion')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Matriculación
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('consultorio')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Consultorio
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Título
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('certificado-etica')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Certificado de Ética
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Ejercicio Profesional */}
            <div className="col-lg-2 col-md-3 col-6">
              <div className="footer-links">
                <h4 style={{
                  color: '#e67e22',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontFamily: "'Poppins', sans-serif"
                }}>Ejercicio Profesional</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('ejercicio-profesional')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Honorarios Mínimos
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('ejercicio-profesional')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Código de Ética
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('ejercicio-profesional')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Consentimiento Informado
                    </a>
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <a href="#" onClick={() => setTabIndex('ejercicio-profesional')} style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.3s ease',
                      fontFamily: "'Inter', sans-serif"
                    }} onMouseEnter={(e) => e.currentTarget.style.color = '#e67e22'} 
                       onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.7)'}>
                      Habilitación de Consultorio
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Redes Sociales y Acceso Rápido */}
            <div className="col-lg-2 col-md-3 col-6">
              <div className="footer-links">
                <h4 style={{
                  color: '#e67e22',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontFamily: "'Poppins', sans-serif"
                }}>Síguenos</h4>
                
                <div className="social-links" style={{ marginBottom: '25px' }}>
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    marginRight: '10px',
                    marginBottom: '10px'
                  }} onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#3b5998';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }} onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <i className="bi bi-facebook" style={{ fontSize: '1rem' }}></i>
                  </a>
                  
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    marginRight: '10px',
                    marginBottom: '10px'
                  }} onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(45deg, #e4405f, #c13584)';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }} onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <i className="bi bi-instagram" style={{ fontSize: '1rem' }}></i>
                  </a>
                  
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'rgba(255, 255, 255, 0.8)',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    marginBottom: '10px'
                  }} onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#0077b5';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }} onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                    <i className="bi bi-linkedin" style={{ fontSize: '1rem' }}></i>
                  </a>
                </div>

                <a className="footer-cta-btn" 
                   href="http://145.223.94.120/" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   style={{
                     display: 'inline-block',
                     background: '#f97316',
                     color: '#ffffff',
                     padding: '10px 18px',
                     borderRadius: '20px',
                     fontWeight: '600',
                     fontSize: '0.85rem',
                     textDecoration: 'none',
                     transition: 'all 0.3s ease',
                     border: 'none',
                     textTransform: 'uppercase',
                     letterSpacing: '0.5px',
                     boxShadow: '0 4px 12px rgba(249, 115, 22, 0.3)'
                   }}
                   onMouseEnter={(e) => {
                     e.currentTarget.style.transform = 'translateY(-2px)';
                     e.currentTarget.style.background = '#ea580c';
                     e.currentTarget.style.boxShadow = '0 6px 18px rgba(249, 115, 22, 0.4)';
                   }}
                   onMouseLeave={(e) => {
                     e.currentTarget.style.transform = 'translateY(0)';
                     e.currentTarget.style.background = '#f97316';
                     e.currentTarget.style.boxShadow = '0 4px 12px rgba(249, 115, 22, 0.3)';
                   }}
                >AUTOGESTION</a>
              </div>
            </div>
          </div>

          {/* Línea divisoria */}
          <hr style={{
            border: 'none',
            height: '1px',
            background: 'rgba(255, 255, 255, 0.1)',
            margin: '40px 0 20px 0'
          }} />

          {/* Copyright */}
          <div className="row">
            <div className="col-md-12 text-center">
              <p style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '0.9rem',
                margin: 0,
                fontFamily: "'Inter', sans-serif"
              }}>
                © {new Date().getFullYear()} <strong style={{ color: '#e67e22' }}>COFOLP</strong>. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>
      
      <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
    </>
  );
};
